import React, { useState, useEffect } from "react";
import "../../scss/componentes.scss";
import { setEstadoConexion } from "../../utils/variablesLocales";
import { Player } from "@lottiefiles/react-lottie-player";
import animacion from "../../imagenes/AnimacionesVarias/NoHayInternet2.json";
import Backdrop from "@mui/material/Backdrop";

const check_status = async () => {
  try {
    return window.navigator.onLine;
  } catch (error) {
    return false;
  }
};

export function SinConexionAInternet() {
  const [EstadoConexion, setEstadoConexion0] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        setInterval(async () => {
          const status = await check_status();
          setEstadoConexion0(status);
          setEstadoConexion(status);
        }, 3000);
      } catch (error) {
        console.error(error);
      }
    })();
  });

  return (
    <div>
      {EstadoConexion !== true ? (
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open="True"
        >
          <Player
            src={animacion}
            className="player"
            loop
            autoplay
            style={{ height: 200 }}
          />
        </Backdrop>
      ) : (
        <div>
          <br></br>
        </div>
      )}
    </div>
  );
}
